"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RioWebClientEventServiceClient = void 0;
var grpcWeb = __importStar(require("grpc-web"));
var webevent_rio_web_client_event_request_pb = __importStar(require("../webevent/rio_web_client_event_request_pb"));
var webevent_rio_web_client_event_response_pb = __importStar(require("../webevent/rio_web_client_event_response_pb"));
var RioWebClientEventServiceClient = (function () {
    function RioWebClientEventServiceClient(hostname, credentials, options) {
        this.methodDescriptorsendWebEvent = new grpcWeb.MethodDescriptor('/com.chegg.rio.sdk.web.RioWebClientEventService/sendWebEvent', grpcWeb.MethodType.UNARY, webevent_rio_web_client_event_request_pb.RioWebClientEventRequest, webevent_rio_web_client_event_response_pb.RioWebClientEventResponse, function (request) {
            return request.serializeBinary();
        }, webevent_rio_web_client_event_response_pb.RioWebClientEventResponse.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'binary';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname.replace(/\/+$/, '');
        this.credentials_ = credentials;
        this.options_ = options;
    }
    RioWebClientEventServiceClient.prototype.sendWebEvent = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/com.chegg.rio.sdk.web.RioWebClientEventService/sendWebEvent', request, metadata || {}, this.methodDescriptorsendWebEvent, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/com.chegg.rio.sdk.web.RioWebClientEventService/sendWebEvent', request, metadata || {}, this.methodDescriptorsendWebEvent);
    };
    return RioWebClientEventServiceClient;
}());
exports.RioWebClientEventServiceClient = RioWebClientEventServiceClient;
